import { SingleToken } from "@/components/single-token";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { getHighlightClasses } from "@/lib/get-tokens-highlights";
import {
  calculateBenchState,
  capitalizeFirst,
  cn,
  toLocaleString,
} from "@/lib/utils";
import { Link } from "react-router-dom";
import { algodNetwork } from "@/lib/algo";
import { ArrowRight } from "lucide-react";
import { BenchStateSmall } from "@myth-finance/bench-sdk";

export function BenchListingCard(benchData: BenchStateSmall) {
  const { benchId } = benchData;
  const { purchaseUnitName, sellingUnitName, remainingTokens, total, price } =
    benchData ?? {};
  const state = benchData ? calculateBenchState(benchData) : "loading";
  const displayState =
    state === "closed" &&
    benchData.timeEnd !== 0 &&
    benchData.timeEnd < benchData.timeStart
      ? "cancelled"
      : state;
  const displayAssetId =
    benchData?.sellingAssetId && algodNetwork === "mainnet"
      ? benchData?.sellingAssetId
      : 2994233666;
  const highlightColor = getHighlightClasses(displayAssetId, "hover:border");
  const usePrecision = (state === "open" ? remainingTokens : total) < 1;
  return (
    <Link to={`/bench/${benchId}`}>
      <Card
        className={cn(
          `min-w-[300px] group rounded-tl-[48px] cursor-pointer ${highlightColor} hover:scale-[1.04] transition-all`
        )}
      >
        <CardHeader className="flex-row gap-4 items-center p-0">
          <SingleToken
            glowing={false}
            className="-left-[1px] -top-[1px] group-hover:-left-[2px] group-hover:-top-[2px]"
            variant="lg"
            assetId={displayAssetId}
          />
          <div className="flex flex-col gap-2 ">
            <CardTitle className="flex gap-1 items-center">
              {purchaseUnitName}
              <ArrowRight className="text-muted-foreground" size={16} />
              {sellingUnitName}
            </CardTitle>
            <CardDescription>{capitalizeFirst(displayState)} bench</CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-4 flex w-full justify-center items-center p-4 text-sm text-muted-foreground">
          {state === "open"
            ? toLocaleString(remainingTokens, usePrecision ? 2 : 0)
            : total
            ? toLocaleString(total, usePrecision ? 2 : 0)
            : "?"}{" "}
          {sellingUnitName} at {price} {purchaseUnitName}
        </CardContent>
      </Card>
    </Link>
  );
}
